import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
} from '@angular/core';
import { randomCharString } from 'src/app/helpers/randomCharString';
const COMPONENT_NAME = 'barcode' as const;

@Component({
    selector: COMPONENT_NAME,
    templateUrl: `./${COMPONENT_NAME}.component.html`,
    styleUrls: [`./${COMPONENT_NAME}.component.scss`],
    standalone: false
})
export class BarcodeComponent implements AfterViewInit, OnChanges, OnDestroy {
    @Input('value') public value: string | number = '';
    @Input('id') public id: string = randomCharString(10);

    private isViewInitialized = false;
    private isDestroyed = false;
    private renderVersion = 0;

    public constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

    public ngAfterViewInit(): void {
        this.isViewInitialized = true;
        void this.renderBarcode();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (
            this.isViewInitialized &&
            (changes['value'] !== undefined || changes['id'] !== undefined)
        ) {
            void this.renderBarcode();
        }
    }

    public ngOnDestroy(): void {
        this.isDestroyed = true;
        this.renderVersion += 1;
    }

    private async renderBarcode(): Promise<void> {
        const svgElement =
            this.elementRef.nativeElement.querySelector<SVGElement>(
                'svg.barcode',
            );

        if (svgElement === null) {
            return;
        }

        const value = this.value.toString();
        const currentRenderVersion = ++this.renderVersion;
        const { default: JsBarcode } = await import('jsbarcode');

        if (
            this.isDestroyed ||
            currentRenderVersion !== this.renderVersion
        ) {
            return;
        }

        JsBarcode(svgElement, value);
    }
}
